import {PinProtect} from '~/features/Auth/PinProtect';
import {UserLookup} from '~/features/UserLookup/UserLookup';

export const UserLookupScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <UserLookup />
      </PinProtect>
    </div>
  );
};
